if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.stripHTML
) {
  Object.defineProperty(String.prototype, 'stripHTML', {
    value({
      makeScreenReaderFriendly,
    } = {}) {
      const div = document.createElement('div');
      div.innerHTML = this;
      if (!makeScreenReaderFriendly) return div.textContent;
      const imgElements = Array.from(div.querySelectorAll('img'));
      const videoElements = Array.from(div.querySelectorAll('video'));
      const inputElements = Array.from(div.querySelectorAll('input'));
      for (const [imgElementIndex, imgElement] of imgElements.entries()) {
        let replacementText = `Image element ${imgElementIndex + 1} of ${imgElements.length}.`;
        const imgAltText = imgElement.getAttribute('alt');
        if (imgAltText) replacementText += ` This image element contains the following alt text: ${imgAltText}`;
        imgElement.parentNode.replaceChild(document.createTextNode(replacementText), imgElement);
      }
      for (const [videoElementIndex, videoElement] of videoElements.entries()) {
        let replacementText = `Video element ${videoElementIndex + 1} of ${videoElements.length}.`;
        const videoAltText = videoElement.getAttribute('alt');
        if (videoAltText) replacementText += ` This video element contains the following alt text: ${videoAltText}`;
        videoElement.parentNode.replaceChild(document.createTextNode(replacementText), videoElement);
      }
      for (const [inputElementIndex, inputElement] of inputElements.entries()) {
        let replacementText = `Input element ${inputElementIndex + 1} of ${inputElements.length}.`;
        const inputValue = inputElement.getAttribute('value');
        if (inputValue) replacementText += ` This input element contains the following value: ${inputValue}`;
        inputElement.parentNode.replaceChild(document.createTextNode(replacementText), inputElement);
      }
      return div.textContent;
    }
  });
}